import { render } from "./section-six.vue?vue&type=template&id=cfea6bba&scoped=true"
const script = {}

import "./section-six.vue?vue&type=style&index=0&id=cfea6bba&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cfea6bba"]])

export default __exports__